import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

const GAP = `var(${spacing.sm})`;
const CARD_COUNT = 4;
// The narrowest desktop content area (976px on a 1024px screen) fits four
// cards; anything narrower keeps the swipeable row.
const FULL_ROW_MIN_WIDTH = '960px';

export const root = css`
  container-type: inline-size;
`;

export const header = css`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(${spacing.md});
  margin-bottom: var(${spacing.md});
`;

export const heading = css`
  margin: 0;
  font-family: var(${typography.heading.fontFamily});
  font-weight: var(${typography.heading.fontWeight});
  font-size: var(${typography.heading.sizes.md.fontSize});
  line-height: var(${typography.heading.sizes.md.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  color: var(${colors.content.default});
`;

export const seeMore = css`
  flex-shrink: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.link});
  text-decoration: underline;
`;

/* Four cards share the row when the container is wide enough for them. In
   less space each card takes most of the width with the next one peeking in,
   which is the cue to swipe. Sized by the container, not the viewport. */
export const track = css`
  display: grid;
  grid-auto-columns: min(85%, 320px);
  grid-auto-flow: column;
  gap: ${GAP};
  margin: 0;
  padding: 0;
  overflow-x: auto;
  list-style: none;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @container (min-width: ${FULL_ROW_MIN_WIDTH}) {
    grid-auto-columns: calc((100% - ${GAP} * ${CARD_COUNT - 1}) / ${CARD_COUNT});
  }
`;

export const item = css`
  scroll-snap-align: start;
`;
